// import { React, useEffect } from "react";
// import { useDeliverySession } from "../../hooks/useDeliverySession";
// // import delivery_type from "../../assets/images/delivery-type.png";
// import delivery_type from "../../assets/images/add_member.png";

// import delivery_scan from "../../assets/images/delivery-scan.png";
// import backArrow from "../../assets/images/back.png";
// import CommonTitle from "../common/DeliveryCommonTitle";
// import { generateUniqueFileCode } from "../../utils/generateUniqueFileCode"; // adjust path as needed

// const AddMembersScreen = ({ onBack, onNext }) => {
//   const { session, updateDeliveryField } = useDeliverySession();

//   useEffect(() => {
//     console.log("Company Image:", session?.company_img);
//     console.log("Company Name:", session?.company_nm);
//   }, [session]);

//   const handleBack = (brand) => {
//     onBack();
//   };

//   const handleNext = () => {
//     const fileCode = generateUniqueFileCode();
//     updateDeliveryField("file_ident_code", fileCode);

//     setTimeout(() => {
//       console.log("✅ Final Session Code:", session?.file_ident_code);
//       onNext();
//     }, 100); // Delay ensures session is updated
//   };

//   return (
//     <div className="w-full min-h-screen px-4 sm:px-6 py-6 relative">
//       <CommonTitle
//         title="ADD+ Members"
//         showTitle={true}
//         showBack={true}
//         onBack={handleBack}
//       />

//       {/* Company Logo */}
//       {/* Company Logo */}
//       <div className="mt-10 flex items-center justify-center">
//         {session.company_img ? (
//           <img
//             src={session.company_img}
//             alt={session.company_nm}
//             className="w-16 h-16 object-contain"
//           />
//         ) : (
//           <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center text-xl font-bold text-gray-600 mb-2">
//             {session.company_nm ? session.company_nm[0] : "?"}
//           </div>
//         )}

//         {/* {session.company_img || (
//           <img
//             src={session.company_img}
//             alt={session.company_nm}
//             className="w-16 h-16 object-contain mx-auto"
//           />
//         )} */}
//       </div>

//       {/* Options: Scan + Type */}
//       <div className="mt-10 flex flex-wrap justify-center items-start gap-10">
//         {/* Scan Card */}
//         {/* <div
//           onClick={() => console.log("Scan clicked")}
//           className="bg-white shadow-md rounded-xl p-6 w-64 text-center cursor-pointer hover:scale-105 transition"
//         >
//           <img
//             src={delivery_scan}
//             alt="Scan"
//             className="w-40 h-40 mx-auto mb-4"
//           />
//           <p className="text-xl font-semibold text-gray-800">Scan</p>
//         </div> */}

//         {/* Type Card */}
//         {/* <div
//           className="bg-white shadow-md rounded-xl p-6 w-[260px] h-[260px] text-center space-y-4 hover:scale-105 transition"
//           onClick={handleNext}
//         > */}
//         {/* <input
//             type="text"
//             placeholder="Resident Name"
//             className="w-full border border-gray-300 rounded-md px-4 py-2 text-center focus:outline-none"
//           />
//           <input
//             type="text"
//             placeholder="Flat Number"
//             className="w-full border border-gray-300 rounded-md px-4 py-2 text-center focus:outline-none"
//           /> */}
//         {/* <img
//             src={delivery_type}
//             alt="Scan"
//             className="w-40 h-40 mx-auto mb-4"
//           />

//           <p className="text-xl font-semibold text-gray-800">Type</p>
//         </div> */}

//         {/* <div
//           className="w-[260px] h-[260px] hover:scale-105 transition overflow-hidden cursor-pointer bg-gray-100"
//           onClick={handleNext}
//         >
//           {" "} */}
//         {/* Reduced padding */}
//         <img
//           src={require("../../assets/images/add_member.png")}
//           alt="Add Member"
//           className="w-[350px] h-[350px] hover:scale-105 transition overflow-hidden cursor-pointer" /* Slightly smaller rounded corners */
//         />
//         {/* </div> */}
//       </div>
//     </div>
//   );
// };

// export default AddMembersScreen;

import { React, useEffect } from "react";
import { useDeliverySession } from "../../hooks/useDeliverySession";
import add_member from "../../assets/images/add_member.png";
import delivery_scan from "../../assets/images/delivery-scan.png";
import CommonTitle from "../common/DeliveryCommonTitle";
import { generateUniqueFileCode } from "../../utils/generateUniqueFileCode";

const AddMembersScreen = ({ onBack, onNext }) => {
  const { session, updateDeliveryField, setSession } = useDeliverySession();

  useEffect(() => {
    // Clear session data when component mounts

    console.log("Company Image:", session?.company_img);
    console.log("Company Name:", session?.company_nm);
    console.log("Current Session:", session);
    console.log("Session cleared and reset");
  }, [session, setSession]);

  useEffect(() => {
    // Clear deliveries only when component mounts
    const clearDeliveries = () => {
      const currentSession = JSON.parse(
        localStorage.getItem("deliverySession") || "{}"
      );

      // Only clear if deliveries exist and are not already empty
      if (currentSession.deliveries && currentSession.deliveries.length > 0) {
        const clearedSession = {
          ...currentSession,
          deliveries: [],
          web_status: "active",
          total_no_of_delivery: 0,
        };

        // Use setSession to update both state and localStorage
        setSession(clearedSession);
        console.log(
          "🧹 Deliveries cleared on AddMembersScreen mount:",
          clearedSession
        );
      }
    };

    clearDeliveries();
  }, []); // Empty dependency array - run only on mount

  const handleBack = (brand) => {
    onBack();
  };

  const handleNext = () => {
    const fileCode = generateUniqueFileCode();
    updateDeliveryField("file_ident_code", fileCode);

    setTimeout(() => {
      console.log("✅ Final Session Code:", session?.file_ident_code);
      onNext();
    }, 100);
  };

  return (
    <div className="w-full min-h-screen px-4 sm:px-6 py-6 relative">
      <CommonTitle
        title="ADD+ Members"
        showTitle={true}
        showBack={true}
        onBack={handleBack}
      />

      {/* Company Logo */}
      <div className="mt-6 flex items-center justify-center">
        {session.company_img ? (
          <img
            src={session.company_img}
            alt={session.company_nm}
            className="w-16 h-16 object-contain"
          />
        ) : (
          <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center text-xl font-bold text-gray-600">
            {session.company_nm ? session.company_nm[0] : "?"}
          </div>
        )}
      </div>

      {/* Single Image Card */}
      <div className="mt-4 flex justify-center items-center">
        <div
          className="p-4 cursor-pointer hover:scale-105 transition"
          onClick={handleNext}
        >
          <img
            src={add_member}
            alt="Add Member"
            className="w-[350px] h-[350px] sm:w-[370px] sm:h-[370px] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default AddMembersScreen;
